function Popups() {
	this.init();
}

Popups.prototype.init = function(target) {
	var self = this;
	var popups = self.getPopupsTS();
	//console.log(popups);

	$.each($('.popups .popups-item'), function(i, v) {
		var tsAdd, tsShow, tsDelta;
		var p = {
			id: parseInt($(v).attr('data-id')),
			show: parseInt($(v).attr('data-show')),
			delay: parseInt($(v).attr('data-delay')),
			show_day: parseInt($(v).attr('data-show_day')),
			show_hour: parseInt($(v).attr('data-show_hour')),
			show_min: parseInt($(v).attr('data-show_min')),
			preview: parseInt($(v).attr('data-preview'))
		};
		//console.log(p);

		if (popups[p.id] != undefined)
			ts = popups[p.id];
		else
			ts = 0;

		if (ts !== 0) {
			//console.log(ts);
			tsAdd = p.show_day * 86400000 + p.show_hour * 3600000 + p.show_min * 60000;
			tsShow = ts + tsAdd;
			tsDelta = tsShow - new Date().getTime();
			//console.log(tsDelta);
		}
		if (ts == 0 || tsDelta<=0 ) {
			if (p.show==1 && p.preview!=1)
				setTimeout(function(){ self.show(p.id); }, p.delay * 1000);
		}
		//podglad
		if (p.preview==1)
			setTimeout(function(){ self.show(p.id); }, 0);
	});

	$('body').on('click', '.popups .popups-item__close', function(e) {
		e.preventDefault();
		$('body').removeClass('-popup');
		$('.popups').removeClass('-active');
		$('.popups .popups-item.-active').removeClass('-active');
	});
};

Popups.prototype.getPopupsTS = function(p) {
	if (localStorage.popups === undefined)
		popups = new Object({});
	else
		popups = JSON.parse(localStorage.getItem('popups'));
	return popups;
};

Popups.prototype.updatePopupsTS = function(id) {
	var self = this;
	popups = self.getPopupsTS();
	popups[id] = new Date().getTime();
	localStorage.setItem('popups', JSON.stringify(popups));
};

Popups.prototype.show = function(id) {
	$('body').addClass('-popup');
	$('.popups .popups-item.-active').removeClass('-active');
	$('.popups .popups-item[data-id='+id+']').addClass('-active');
	$('.popups').addClass('-active');
	this.updatePopupsTS(id);
};

showPopup = function(id) {
	$('body').addClass('-popup');
	app.popups.show(id);
};

closePopup = function(id) {
	$('.popups .popups-item[data-id='+id+']').removeClass('-active');
	$('.popups').removeClass('-active');
	$('body').removeClass('-popup');
};